export const TYPES = {
  SET_FINANCE_MANAGER_ALL: "finance_manager/SET_FINANCE_MANAGER_ALL",
  SET_FINANCE_MANAGER_OPEN_ADD:
    "finance_manager/SET_FINANCE_MANAGER_OPEN_ADD",
  SET_FINANCE_MANAGER_OPEN_EDIT:
    "finance_manager/SET_FINANCE_MANAGER_OPEN_EDIT",
  SET_FINANCE_MANAGER_SELECTED:
    "finance_manager/SET_FINANCE_MANAGER_SELECTED",
  SET_FINANCE_MANAGER_SEARCH:
    "finance_manager/SET_FINANCE_MANAGER_SEARCH",
  SET_FINANCE_MANAGER_DATES: "finance_manager/SET_FINANCE_MANAGER_DATES",
};
